import React from 'react';

import ReactDOM from 'react-dom';
import singleSpaReact from 'single-spa-react';

import { App } from './App';
import './i18n';

let reactAppEnv = process.env.APP_ENV;

// Add this part to the file to import GTM
if (process.env.APP_ENV !== 'development') {
  // require('./libs/gtm');
  if (reactAppEnv === 'staging') {
    reactAppEnv = 'stg';
  }
}

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  loadRootComponent: () => {
    return new Promise<React.FunctionComponent>((resolve) => {
      resolve(App as React.FunctionComponent);
    });
  },
  errorBoundary(err, _info, _props) {
    throw err;
  },
});

export const { bootstrap, mount, unmount } = lifecycles;
